import React, { Fragment, useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const textStyle = {
  root: {
    color: '#A80000',
    lineHeight: '24px',
  },
};

export const ErrorString = ({
  error,
}) => {
  const i18n = useContext(I18nContext);

  return (
    <Fragment>
      <Text
        variant="medium"
        block
        nowrap
        styles={textStyle}
        title={error ? i18n.getString(error) : ''}
      >
        {error && i18n.getString(error)}
      </Text>
    </Fragment>);
};

ErrorString.propTypes = {
  error: PropTypes.string.isRequired,
};
